import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_vm.showTaskDialog ? _c('core-csv-export-dialog-scheduled', {
    attrs: {
      "editObject": _vm.jobObject,
      "copyMode": _vm.copyMode
    },
    on: {
      "close": function ($event) {
        _vm.showTaskDialog = false;
        _vm.copyMode = false;
        _vm.jobObject = null;
      },
      "save": _vm.updateList
    }
  }) : _vm._e(), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('BackgroundJobs.ScheduledExports.title'),
      "subtitle": _vm.$i18n_t('BackgroundJobs.ScheduledExports.subtitle')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "ready": function ($event) {
              _vm.accountFilterReady = true;
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.create'),
            "prepend-icon": "fa-plus"
          },
          on: {
            "click": function ($event) {
              _vm.showTaskDialog = true;
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('Common.create')) + "\n        ")])];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c('core-csv-export-list-scheduled', {
    ref: "list",
    attrs: {
      "search": _vm.search,
      "accounts": _vm.selectedAccounts
    },
    on: {
      "show-details": _vm.showDetails
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };